module.exports = __webpack_public_path__ + "img/about-img-2.dadb34c0.webp";